export const ENABLE_RESOURCE_BOOKING_SERVICE = 'enable-resource-booking-microservice-endpoints';
